<div class="container" [class.black-theme]="isBlackTheme">
	<ng-container [ngSwitch]="description">
		<div i18n *ngSwitchCase="'REQUEST_PROCESSING'">Обработка запроса</div>
		<div i18n *ngSwitchCase="'SAVE'">Сохранение</div>
		<div i18n *ngSwitchCase="'SEND'">Отправка</div>
		<div i18n *ngSwitchCase="'SIGN'">Подписание</div>
		<div i18n *ngSwitchCase="'DELETE'">Удаление</div>
		<div i18n *ngSwitchCase="'CANCEL'">Отмена</div>
		<div i18n *ngSwitchCase="'CREATE_REGISTRY'">Формирование реестра</div>
		<div i18n *ngSwitchCase="'CHECK_VERSION'">Проверка версии <i>SC-CryptoProxy</i></div>
		<div i18n *ngSwitchCase="'CREATE_INVITATION'">Оформление приглашений</div>
		<div i18n *ngSwitchCase="'EDIT_INVITATION'">Редактирование приглашения</div>
		<div i18n *ngSwitchCase="'GET_MARKS_PARAMS'">Получение параметров для маркировки</div>
		<div i18n *ngSwitchCase="'LOADING_FILE'">Загрузка файла</div>
		<div i18n *ngSwitchCase="'SC_CRYPTO_ANSWER'">Ожидание ответа SC-CryptoProxy</div>
		<div i18n *ngSwitchCase="'CRYPTO_PRO_ANSWER'">Ожидание ответа КриптоПро</div>
		<div i18n *ngSwitchCase="'AGGREGATION'">Агрегирование</div>
		<div i18n *ngSwitchCase="'DISAGGREGATION'">Дезагрегирование</div>
		<div i18n *ngSwitchCase="'WRITE_OF'">Списание</div>
		<div i18n *ngSwitchCase="'SAVE_FILE'">Сохранение файла</div>
		<div i18n *ngSwitchCase="'CREATE_REQUESTS'">Оформление запросов</div>
		<div i18n *ngSwitchCase="'IMPORT'">Импорт</div>
		<div i18n *ngSwitchCase="'SEND_DATA'">Данные отправляются</div>
		<div i18n *ngSwitchCase="'TREE_CONSTRUCTION'">Идет построение дерева кодов</div>
		<div *ngSwitchDefault>
			<ng-content></ng-content>
		</div>
	</ng-container>
	
	<div class="sk-fading-circle">
		<div class="sk-circle1" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle2" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle3" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle4" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle5" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle6" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle7" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle8" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle9" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle10" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle11" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
		<div class="sk-circle12" [ngClass]="isBlackTheme ? 'sk-black-circle' : 'sk-circle'"></div>
	</div>
</div>
